import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { SortDirection } from 'types/common';

import './index.scss';

interface Props {
  actual?: SortDirection;
  onClick: (value: SortDirection) => void;
}

const b = b_.with('stocks-filter-order');

class Order extends React.Component<Props & InjectedTranslateProps> {
  render() {
    const { t, actual, onClick } = this.props;

    return (
      <div className={b()}>
        <div
          className={b('item', { active: actual === SortDirection.desc })}
          onClick={() => onClick(SortDirection.desc)}
        >
          {t('Sort descending')}
        </div>
        <div
          className={b('item', { active: actual === SortDirection.asc })}
          onClick={() => onClick(SortDirection.asc)}
        >
          {t('Sort ascending')}
        </div>
      </div>
    );
  }
}
export default translate(Order);
